angular.module('surfsightApp.controllers').controller('forgotPasswordCtrl', [
  '$scope',
  '$http',
  '$state',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  '$interval',
  '$filter',
  function (
    $scope,
    $http,
    $state,
    $localStorage,
    $mdDialog,
    $mdToast,
    $interval,
    $filter
  ) {
    $scope.forgotpassword_data = {}
    var $translate = $filter('translate')
    $scope.forgotPassword = function () {
      var email = $scope.forgotpassword_data.email
      var request_json = {
        method: 'POST',
        url: USER_BASEURL + '/forgetpassword/' + email,
        data: {},
        headers: {
          Authorization: 'dummy'
        }
      }
      $http(request_json).then(
        function (response) {
          // console.log('forgot password response');
          // console.log(response);
          if (response.data.status.code == 0) {
            $mdDialog.hide(response)
          } else {
            alert(response.data.status.error)
          }
        },
        function (response) {
          alert($translate('errorOccurredPleaseTryAgain'))
        }
      )
    }
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
  }
])
